import { http } from '~/utils/fetch'

export interface ApplyPartnerPayload {
  company: string
  contacts: string
  phone: string
  remark: string
}

/**
 * 留言咨询
 */
export const applyPartner = (data: ApplyPartnerPayload) => {
  return http.request<unknown>({
    url: '/app/hgj/partners',
    method: 'POST',
    data,
  })
}
